import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import styles from './AmbulatoryQuote.module.sass'
import { useState } from 'react'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import splitMedicalAct from 'utils/splitMedicalAct'

export const isKeyExcluded = (key) =>
	['medicalActs', 'appointments', 'provider', 'includedItems'].includes(key)

const RowCell = (props) => {
	const { row, columnName, strong, ...attributes } = props

	const renderCell = () => {
		if (columnName === 'product' && row.hasOwnProperty('provider')) {
			const { code, description } = splitMedicalAct(row[columnName])

			return (
				<VStack>
					<span>
						<small>
							<strong>{code}</strong>
						</small>
						<small> - {description}</small>
					</span>
					<small>{row['provider']}</small>
				</VStack>
			)
		}
		return strong && columnName === 'product' ? (
			<strong>{row[columnName]}</strong>
		) : (
			<small>{row[columnName]}</small>
		)
	}

	return <td {...attributes}>{renderCell()}</td>
}

const TableRow = ({ row, expandable, strong }) => {
	const [expanded, setExpanded] = useState(true)

	const handleExpandRow = () => {
		setExpanded(!expanded)
	}

	const renderNestedList = () => {
		if (row?.appointments?.length) {
			return (
				<tr className={styles['child-row']}>
					<td colSpan='4'>
						<VStack>
							{row.appointments.map((appointment, index) => (
								<small key={index}>{appointment.name}</small>
							))}
						</VStack>
					</td>
				</tr>
			)
		}

		if (row?.medicalActs?.length) {
			return (
				<tr className={styles['child-row']}>
					<td colSpan='4'>
						<VStack>
							{row.medicalActs.map((act, index) => (
								<small key={index}>{act.name}</small>
							))}
						</VStack>
					</td>
				</tr>
			)
		}

		if (row?.includedItems?.length) {
			return (
				<tr className={styles['child-row']}>
					<td colSpan='4'>
						<VStack>
							{row.includedItems.map((item, index) => {
								const { code, description } = splitMedicalAct(
									item.product
								)

								return (
									<small key={index}>
										{item.quantity}x <strong>{code}</strong>{' '}
										{description}
									</small>
								)
							})}
						</VStack>
					</td>
				</tr>
			)
		}

		return null
	}

	return (
		<>
			<tr>
				{Object.keys(row).map(
					(columnName) =>
						!isKeyExcluded(columnName) && (
							<RowCell
								key={columnName}
								columnName={columnName}
								row={row}
								strong={strong}
								onClick={
									expandable ? handleExpandRow : undefined
								}
							/>
						)
				)}
			</tr>
			{expanded && renderNestedList()}
		</>
	)
}

const TableBody = ({ data, expandable, strong }) => {
	return data.map((row, index) => {
		return (
			<TableRow
				expandable={expandable}
				key={index}
				row={row}
				strong={strong}
			/>
		)
	})
}

export const TableHeader = ({ headers }) => {
	const { i18n } = useGlobal()

	return (
		<thead>
			<tr>
				{headers.map(
					(header, index) =>
						!isKeyExcluded(header) && (
							<th key={index}>
								<strong>{i18n.translate(header)}</strong>
							</th>
						)
				)}
			</tr>
		</thead>
	)
}

const AmbulatoryQuoteTable = ({
	data,
	header = true,
	expandable = false,
	strong = false,
}) => {
	return data?.length ? (
		<table
			className={`${styles['styled-table']} ${
				header ? '' : styles['--header-hidden']
			} ${expandable ? styles['--expandable'] : ''}`}
		>
			<TableHeader headers={Object.keys(data[0])} />
			<tbody>
				<TableBody
					data={data}
					expandable={expandable}
					strong={strong}
				/>
			</tbody>
		</table>
	) : null
}

export default AmbulatoryQuoteTable
